import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import DatasetPanelFull from '../containers/DatasetPanelFull';
import DatasetPanelNarrow from '../containers/DatasetPanelNarrow';

const DatasetPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: DatasetPanelFull, narrow: DatasetPanelNarrow }}
    onChange={onChange}
    width={620}
  />
);

export default DatasetPanel;
